(ns minorodata.unleash.subs
  (:require [re-frame.core :as re-frame]
            [minorodata.unleash.core :refer [unleash]]))


(re-frame/reg-sub
 :unleash/timestamp
 (fn [db _]
   (get db :unleash/timestamp)))


(re-frame/reg-sub
 :unleash/loaded-user-id
 (fn [db _]
   (get db :unleash/loaded-user-id)))


(re-frame/reg-sub
 :unleash/is-enabled
 :<- [:unleash/timestamp]
 (fn [_ [_ feature-name]]
   (.isEnabled unleash feature-name)))


(re-frame/reg-sub
 :unleash/get-variant
 :<- [:unleash/timestamp]
 (fn [_ [_ feature-name]]
   (js->clj
    (.getVariant unleash feature-name)
    :keywordize-keys true)))

(re-frame/reg-sub
 :unleash/get-context
 :<- [:unleash/timestamp]
 (fn [_ _]
   (js->clj
    (.getContext unleash)
    :keywordize-keys true)))
